<template>
    <div class="modal fade"
        :style="'cursor: url('+cursorImage()+'), auto !important'"
        :id="modalId" tabindex="-1"
        role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-body d-flex flex-column justify-content-center modal-alert">
                    <h3 class="text-center font-weight-bold mt-4">{{ $t('contract_selected') }}</h3>
                    <h4 v-if="contractNumber" class="text-center">{{ contractNumber }}</h4>
                    <p>The duplicate contract will have the following number <strong>{{ inputs.contractNumber }}</strong> </p>
                    <div class="text-center">
                        <button type="button" class="btn btn-primary mr-2 btn btn-success" @click.prevent="confirmed">
                            {{ $t('duplicate_contract') }}
                        </button>
                        <a href="#" class="btn btn-secondary mr-2" @click.prevent="cancelled">
                            {{ secondButtonName ? secondButtonName : $t('no') }}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AppFunction from "../../../../core/helpers/app/AppFunction";

export default {
    name: "DeleteModal",
    props: {
        modalId: {
            type: String,
            required: true
        },
        contractId : Number,
        message: String,
        firstButtonName: String,
        secondButtonName: String,
        preloader: {
            type: Boolean,
            default: false
        },
        title: String,
        subTitle: String,
        icon: String,
        modalClass: String
    },
    data() {
        return {
            contractNumber: null,
            inputs: {
                country: {
                id: null,
                name: null,
                Code: null,
                },
                category: {
                id: null,
                name: null,
                code: null
                },
                contractNumber: '',
                contract_number_r: '',
            },
            initialContractNumber: 10000,
        }
    },

    async mounted() {  
        await this.getNum();  
        $('.modal').on('shown.bs.modal', () => {
            $('html').css('overflow-y', 'hidden');
        });

        $('#' + this.modalId).on('hidden.bs.modal', () => {
            $('html').css('overflow-y', 'auto');
            this.closed();
        });

        $('#' + this.modalId).modal('show');
        await this.loadData(this.contractId);
        await this.updateContractNumber(_);
        this.$emit('update-contract-number', this.inputs.contractNumber);
    },
    methods: {
        async loadData(contractId) {
            try {
                const response = await axios.get(`/contracts/get_contract_details/${contractId}`);
                const data = response.data;
                if (data.length > 0) {
                    const res = data[0];
                    this.contractNumber = res.number;
                }
            } catch (error) {
                console.log(error);
            }
        },
        cursorImage() {
            return this.$store.state.theme.darkMode 
                ? AppFunction.getAppUrl('images/close-cursor-dark.png') 
                : AppFunction.getAppUrl('images/close-cursor-light.png');
        },
        confirmed() {
            // Cerrar el modal antes de emitir el evento
            $('#' + this.modalId).modal('hide');
            this.$emit('confirmed_duplicate', false);
        },
        cancelled() {
            // Cerrar el modal antes de emitir el evento de cancelación
            $('#' + this.modalId).modal('hide');
            this.closed();
        },
        closed() {
            this.$emit('cancelled_duplicate', false);
        },
        async getNum() {
            try {
                const response = await axios.get('/contracts/serverside/contract-number');
                this.inputs.contract_number_r = (response.data == '0') ? 1 : response.data;
            } catch (error) {
                console.error('Error fetching contract number:', error);
            }
        },

        async updateContractNumber(_) {
            const formatted = this.contractNumber.substring(0 ,3);       
            const number = 1000 + (parseInt(this.inputs.contract_number_r) + 1);
            this.inputs.contractNumber = `${formatted}${number}`;
        },
    }
}
</script>
